export default "__VITE_ASSET__DCRRlf43__"